(function () {
  document.querySelectorAll('[data-shop-lola]').forEach(function (section) {
    initQuantity(section);
    initTabs(section);
    initVariants(section);
    initAddToCart(section);
    initMediaHeight(section);
  });

  // Iguala la altura de la columna de imagen a la altura real ya
  // renderizada de la columna de texto (.info), solo en desktop (donde
  // el grid pasa a 2 columnas lado a lado) — así la imagen del
  // producto queda alineada arriba y abajo con el texto, sin importar
  // qué tan vertical/horizontal sea la proporción de la foto subida.
  // Se usa JS en vez de un porcentaje en CSS porque una altura
  // porcentual dentro de este grid genera una referencia circular (el
  // navegador no puede resolver "100% de qué" cuando ambas columnas
  // dependen del mismo alto de fila), lo que termina inflando la
  // sección entera a una altura desproporcionada.
  function initMediaHeight(section) {
    var info = section.querySelector('.shop-lola__info');
    var media = section.querySelector('.shop-lola__media');
    if (!info || !media) return;

    var breakpoint = window.matchMedia('(min-width: 990px)');

    function sync() {
      if (breakpoint.matches) {
        media.style.height = info.offsetHeight + 'px';
      } else {
        // Mobile/tablet: la columna de imagen vuelve a su alto natural
        // (ancho completo, alto proporcional) — sin esto, quedaría
        // atascada en el último valor en px calculado para desktop.
        media.style.height = '';
      }
    }

    sync();
    window.addEventListener('resize', sync);
    breakpoint.addEventListener('change', sync);

    // Si el contenido de .info cambia de alto después de la carga
    // inicial (ej. al cambiar de variante y aparecer/desaparecer el
    // precio tachado), la columna de imagen se reajusta sola.
    if ('ResizeObserver' in window) {
      new ResizeObserver(sync).observe(info);
    }
  }

  // Minimal, self-contained clone of Shopify's money formatter — avoids
  // depending on a global helper that may or may not exist in this
  // theme, using the shop's own money_format string (passed down via
  // data-money-format) so the currency symbol/decimal style always
  // matches what the store already shows everywhere else.
  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');

    function withDots(intPart) {
      return intPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }

    var amount = parts[0] + ',' + parts[1];
    var amountNoDecimals = parts[0];
    var amountWithCommaSeparator = withDots(parts[0]) + ',' + parts[1];
    var amountNoDecimalsWithCommaSeparator = withDots(parts[0]);

    if (!format) {
      return amountWithCommaSeparator + ' €';
    }

    return format
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountNoDecimalsWithCommaSeparator)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountWithCommaSeparator)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  // Variant picker (size): swaps the hidden variant id the form submits,
  // re-renders the price (+ compare-at price if the new variant has
  // one), and disables/relabels the add-to-cart button if the chosen
  // size is sold out — all without a page reload, since there's only
  // ever one option (size) so no need for a full option-matching engine.
  function initVariants(section) {
    var buttons = Array.prototype.slice.call(section.querySelectorAll('[data-shop-lola-variant-btn]'));
    if (!buttons.length) return;

    var moneyFormat = section.getAttribute('data-money-format');
    var variantInput = section.querySelector('[data-shop-lola-variant-input]');
    var priceCurrent = section.querySelector('[data-shop-lola-price-current]');
    var priceCompare = section.querySelector('[data-shop-lola-price-compare]');
    var taxNote = section.querySelector('[data-shop-lola-tax-note]');
    var addToCartBtn = section.querySelector('[data-shop-lola-add-to-cart]');

    function selectVariant(button) {
      buttons.forEach(function (btn) {
        btn.classList.toggle('is-active', btn === button);
        btn.setAttribute('aria-pressed', String(btn === button));
      });

      var variantId = button.getAttribute('data-variant-id');
      var price = parseInt(button.getAttribute('data-variant-price'), 10);
      var compareAtPrice = parseInt(button.getAttribute('data-variant-compare-at-price'), 10);
      var available = button.getAttribute('data-variant-available') === 'true';

      if (variantInput) variantInput.value = variantId;

      if (priceCurrent && !isNaN(price)) {
        if (available) {
          priceCurrent.textContent = formatMoney(price, moneyFormat);
        } else {
          // Sold out on request: the size button itself stays fully
          // enabled/clickable (no disabled/strikethrough treatment
          // anymore — see the Liquid template), but selecting it swaps
          // the price display to this label instead of a price.
          var soldLabel = priceCurrent.getAttribute('data-sold-out-price-label') || 'Nicht auf Lager';
          priceCurrent.textContent = soldLabel;
        }
      }

      if (priceCompare) {
        if (available && !isNaN(compareAtPrice) && compareAtPrice > price) {
          priceCompare.textContent = formatMoney(compareAtPrice, moneyFormat);
          priceCompare.hidden = false;
        } else {
          priceCompare.hidden = true;
        }
      }

      // Tax note ("inkl. Mwst.") only makes sense next to an actual
      // price — hidden whenever the selected variant isn't available
      // (the price display shows the sold-out label instead), shown
      // again as soon as an in-stock variant is selected.
      if (taxNote) {
        taxNote.hidden = !available;
      }

      if (addToCartBtn) {
        addToCartBtn.disabled = !available;
        var label = available
          ? addToCartBtn.getAttribute('data-add-label')
          : addToCartBtn.getAttribute('data-sold-out-label');
        if (label) addToCartBtn.textContent = label;
      }
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.disabled) return;
        selectVariant(button);
      });
    });
  }

  // Quantity stepper: plain number input underneath, +/- buttons just
  // nudge its value. min="1" on the input itself is the native/no-JS
  // fallback; this only adds the nicer button interaction on top.
  function initQuantity(section) {
    var wrapper = section.querySelector('[data-shop-lola-quantity]');
    if (!wrapper) return;

    var input = wrapper.querySelector('[data-shop-lola-qty-input]');
    var minusBtn = wrapper.querySelector('[data-shop-lola-qty-minus]');
    var plusBtn = wrapper.querySelector('[data-shop-lola-qty-plus]');
    if (!input) return;

    function currentValue() {
      var value = parseInt(input.value, 10);
      return isNaN(value) || value < 1 ? 1 : value;
    }

    if (minusBtn) {
      minusBtn.addEventListener('click', function () {
        input.value = Math.max(1, currentValue() - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    if (plusBtn) {
      plusBtn.addEventListener('click', function () {
        input.value = currentValue() + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    input.addEventListener('change', function () {
      input.value = currentValue();
    });
  }

  // Tabs: simple show/hide, one panel visible at a time. Built with
  // role="tab"/"tabpanel" + aria-selected/aria-controls already in the
  // markup, so this just keeps the visual state and the ARIA state in
  // sync with whichever tab was clicked.
  function initTabs(section) {
    var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-shop-lola-tab]'));
    var panels = Array.prototype.slice.call(section.querySelectorAll('[data-shop-lola-panel]'));
    if (!tabs.length) return;

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        panels.forEach(function (panel) {
          panel.classList.remove('is-active');
          panel.hidden = true;
        });

        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');

        var panel = panels[index];
        if (panel) {
          panel.classList.add('is-active');
          panel.hidden = false;
        }
      });
    });
  }

  // Agregar al carrito vía AJAX (API nativa de Shopify), en vez de un
  // envío de formulario normal que recarga la página — así el Cart
  // Drawer (cart-drawer-lola) puede abrirse mostrando el producto recién
  // agregado, sin que el visitante pierda el lugar donde estaba
  // explorando. Si por algún motivo el drawer no está disponible en la
  // página (ej. "Cart type" no está en "Drawer"), el formulario se
  // comporta exactamente igual que antes — no interceptamos nada.
  function initAddToCart(section) {
    var form = section.querySelector('.shop-lola__form');
    if (!form) return;

    // IMPORTANTE: no se comprueba aquí si el drawer ya está listo — en
    // este punto (justo al cargar la página) casi nunca lo está,
    // porque cart-drawer.js se carga al final de la página mientras
    // que este script se carga más arriba, y ambos usan "defer" (se
    // ejecutan en orden de aparición en el HTML). La comprobación real
    // se hace más abajo, dentro del propio evento de envío — para
    // cuando el usuario hace clic, todos los scripts ya terminaron de
    // cargar hace rato, sin importar el orden entre ellos.
    form.addEventListener('submit', function (evt) {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer || typeof drawer.renderContents !== 'function') {
        // El drawer no está disponible en absoluto (ej. "Cart type" no
        // está en "Drawer" en Theme Settings) — se deja el envío
        // nativo normal, sin interceptar nada.
        return;
      }

      evt.preventDefault();

      var submitBtn = form.querySelector('[data-shop-lola-add-to-cart]');
      var originalLabel = submitBtn ? submitBtn.textContent : null;
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = submitBtn.getAttribute('data-adding-label') || submitBtn.textContent;
      }

      var formData = new FormData(form);
      // Pide de vuelta el HTML ya renderizado de estas dos "secciones"
      // junto con la respuesta de agregar el producto, en una sola
      // llamada — así el drawer y el contador del ícono se actualizan
      // sin una segunda petición.
      formData.append('sections', 'cart-drawer,cart-icon-bubble');
      formData.append('sections_url', window.location.pathname);

      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (data && data.status) {
            // Respuesta de error de Shopify (ej. se agotó el stock justo
            // en ese momento) — fallback seguro: enviar el formulario de
            // forma nativa, tal como se comportaba antes de este cambio.
            form.submit();
            return;
          }

          // El HTML de "sections" que llega en ESTA MISMA respuesta de
          // /cart/add.js puede reflejar el carrito una fracción de
          // segundo antes de que Shopify termine de registrar el
          // artículo — especialmente notorio al pasar de 0 a 1
          // productos (el contador de cart-icon-bubble sí llega
          // actualizado porque es una sección mucho más simple, pero la
          // tabla completa de cart-drawer a veces no). Para no
          // depender de esa posible "foto vieja", se pide el HTML del
          // drawer en una SEGUNDA llamada, separada y de solo lectura
          // (GET a /cart, sin mutar nada), que siempre parte de un
          // carrito ya 100% confirmado en el servidor.
          return fetch(
            (window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') +
              '?sections=cart-drawer,cart-icon-bubble'
          )
            .then(function (sectionsResponse) {
              return sectionsResponse.json();
            })
            .then(function (sectionsData) {
              drawer.renderContents({ id: data.id, sections: sectionsData });
            });
        })
        .catch(function () {
          // Error de red — mismo fallback seguro.
          form.submit();
        })
        .finally(function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            if (originalLabel) submitBtn.textContent = originalLabel;
          }
        });
    });
  }
})();